module.exports = "/assets/e686b49c0488eb5dfb4db92fad216246.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/P2.png
// module id = 1701
// module chunks = 0